import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { Auth } from "aws-amplify";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import { selectRegisterData, selectRegisterStatus, selectRegisterError, initializeAsync } from "./registerSlice";

import { get, post } from "../../api";
import "./style.css";
// Add custom imports here

import {
    Button,
    CssBaseline,
    Box,
    Paper,
    Menu,
    MenuItem,
    Container,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Backdrop,
    CircularProgress,
    Alert,
    AlertTitle,
    Snackbar,
    TextField,
} from "@mui/material";

import LoadingButton from "@mui/lab/LoadingButton";
import { updateApplicant } from "../../utils";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { SimpleHeader } from "../../components/SimpleHeader";

// Add custom imports here

const Register = () => {
    const data = useSelector(selectRegisterData);
    const status = useSelector(selectRegisterStatus);
    const error = useSelector(selectRegisterError);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const { passwordLessLogin, login, isAuthenticated } = useAuth();
    const [openToster, setOpenToster] = useState(false);
    const [tosterVariant, setTosterVariant] = useState("error");
    const [tosterMessage, setTosterMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [displayBox, setDisplayBox] = useState(false);
    const [details, setDetails] = useState({
        firstName: "",
        lastName: "",
        phone: "",
        accountName: "",
        email: location?.state?.searchParams?.email,
    });

    const firstNameRef = useRef();
    const lastNameRef = useRef();
    const phoneRef = useRef();
    const accountNameRef = useRef();

    const refs = [firstNameRef, lastNameRef, phoneRef, accountNameRef];

    // Add Variables

    React.useEffect(() => {
        setTimeout(() => {
            setDisplayBox(true);
        }, 1500);
    }, []);

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    if (!location?.state?.searchParams?.email) {
        window.location.href = "/login";
        return;
    }

    const handleChange = (key, value) => {
        let data = { ...details };
        data[key] = value;

        setDetails(data);
    };

    const handleTosterClose = () => {
        setOpenToster(false);
    };

    const handleClick = async () => {
        let authenticated = await isAuthenticated();
        if (authenticated) {
            window.location.href = "/";
            return;
        }
        if (validate()) {
            setLoading(true);
            let record = { ...details };
            console.log(record);
            post(`contact/createContact`, record).then(async (result) => {
                if (result.isSuccess && result.data === true) {
                    passwordLessLogin({
                        email: record.email,
                        callback: (failed) => {
                            if (failed) {
                                setTosterVariant("error");
                                setTosterMessage(`Sorry, we don't recognize this email address`);
                                setOpenToster(true);
                            }
                            setLoading(false);
                        },
                    });
                } else {
                    setTosterVariant("error");
                    setTosterMessage(
                        `There was a problem with starting your application. Please contact support at (877) 958-1888.`
                    );
                    setOpenToster(true);
                    setLoading(false);
                }
            });
        }
    };

    const validate = () => {
        if (details.firstName && details.lastName && details.phone && details.accountName) {
            return true;
        }
        return false;
    };

    let body = (
        <Box
            component="main"
            sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                backgroundColor: "black",
            }}>
            <SimpleHeader></SimpleHeader>
            <Box
                sx={{
                    alignItems: "center",
                    display: "flex",
                    flexGrow: 1,
                    minHeight: "100%",
                    backgroundColor: "black",
                }}>
                <Container
                    className={displayBox ? "fade-in show" : "fade-in"}
                    maxWidth="sm"
                    sx={{
                        maxWidth: "450px !important",
                        justifyContent: "center",
                        mt: "-6rem",
                    }}>
                    <CssBaseline />
                    <Paper
                        elevation={16}
                        sx={{
                            backgroundColor: "rgb(255, 255, 255)",
                            color: "rgb(18, 24, 40)",
                            transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                            borderRadius: "0px",
                            boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                            backgroundImage: "none",
                            overflow: "hidden",
                            padding: "32px",
                        }}>
                        <Box sx={{ textAlign: "center" }}>
                            <Typography component="h1" variant="h4">
                                Sign up!
                            </Typography>
                            <Typography
                                align="center"
                                color="textSecondary"
                                variant="subtitle1"
                                margin="1rem"
                                fontSize="0.875rem"
                                sx={{ fontWeight: "400", lineHeight: "20px" }}>
                                Let's create an account.
                            </Typography>
                        </Box>
                        <Box validate sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="firstName"
                                label="First name"
                                name="firstName"
                                autoFocus
                                value={details.firstName}
                                ref={firstNameRef}
                                sx={{ borderRadius: "8px", height: "auto" }}
                                variant="outlined"
                                autoComplete="off"
                                onChange={(event) => handleChange("firstName", event.target.value)}
                            />

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="lastName"
                                label="Last name"
                                name="lastName"
                                value={details.lastName}
                                ref={lastNameRef}
                                sx={{ borderRadius: "8px", height: "auto" }}
                                variant="outlined"
                                autoComplete="off"
                                onChange={(event) => handleChange("lastName", event.target.value)}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                type="number"
                                id="phone"
                                label="Phone number"
                                name="phone"
                                value={details.phone}
                                ref={phoneRef}
                                sx={{ borderRadius: "8px", height: "auto" }}
                                variant="outlined"
                                autoComplete="off"
                                onChange={(event) => handleChange("phone", event.target.value)}
                            />

                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="orgName"
                                label="Organization name"
                                name="accountName"
                                value={details.accountName}
                                ref={accountNameRef}
                                sx={{ borderRadius: "8px", height: "auto" }}
                                variant="outlined"
                                autoComplete="off"
                                onChange={(event) => handleChange("accountName", event.target.value)}
                            />

                            <LoadingButton
                                size="small"
                                type="submit"
                                color="dark"
                                disabled={
                                    details?.firstName && details?.lastName && details?.phone && details?.accountName
                                        ? false
                                        : true
                                }
                                fullWidth
                                loading={loading}
                                loadingPosition="end"
                                variant="contained"
                                onClick={handleClick}
                                sx={{ mt: 3, mb: 2, height: "45px" }}>
                                Submit
                            </LoadingButton>
                        </Box>
                    </Paper>
                    <Grid container sx={{ marginTop: "-2rem", width: "100%" }}>
                        <Grid item xs={4} sx={{ height: "10px", background: "white" }}></Grid>
                        <Grid item xs={4} sx={{ height: "30px", background: "white" }}></Grid>
                        <Grid item xs={4} sx={{ height: "50px", background: "white" }}></Grid>
                    </Grid>
                </Container>
            </Box>

            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={openToster}
                autoHideDuration={6000}
                onClose={handleTosterClose}>
                <Alert onClose={handleTosterClose} severity={tosterVariant} variant="filled">
                    {tosterMessage}
                </Alert>
            </Snackbar>
        </Box>
    );

    return getPageContent(body, status, error);
};

export { Register };
